export default __webpack_public_path__ + "static/media/bannerCrisBarrosMobile.c546c147.svg";